<template>
<div class="chapter">
<div class="inner_page">
<p class="C94"><span class="size_80"><span id="page_vii">CONTENTS</span></span></p>
<p class="C95"><em><a href="#/xhtml/05_Foreword#page_ix">Foreword</a> by David Crystal</em></p>
<p class="C89"><em><a href="#/xhtml/06_Preface#page_xi">Preface</a></em></p>
<p class="C155"><a href="#/xhtml/07_1__A_New#page_1">1</a></p>
<p class="C91"><strong><a href="#/xhtml/07_1__A_New#page_1">A New Era</a></strong></p>
<p class="C155"><span href="#/xhtml/08_2__Globa#page_24" title="Link target outside of Sample">2</span></p>
<p class="C91"><strong><span href="#/xhtml/08_2__Globa#page_24" title="Link target outside of Sample">Global English</span></strong></p>
<p class="C91"><em><span href="#/xhtml/08_2__Globa#page_24" title="Link target outside of Sample">Realities, Geopolitics, Issues</span></em></p>
<p class="C155"><span href="#/xhtml/09_3__Engli#page_68" title="Link target outside of Sample">3</span></p>
<p class="C91"><strong><span href="#/xhtml/09_3__Engli#page_68" title="Link target outside of Sample">English and Science</span></strong></p>
<p class="C91"><em><span href="#/xhtml/09_3__Engli#page_68" title="Link target outside of Sample">The Current Landscape</span></em></p>
<p class="C155"><span href="#/xhtml/10_4__Impac#page_102" title="Link target outside of Sample">4</span></p>
<p class="C91"><strong><span href="#/xhtml/10_4__Impac#page_102" title="Link target outside of Sample">Impacts</span></strong></p>
<p class="C91"><em><span href="#/xhtml/10_4__Impac#page_102" title="Link target outside of Sample">A Discussion of Limitations and Issues for a Global Language</span></em></p>
<p class="C155"><span href="#/xhtml/11_5__Past#page_132" title="Link target outside of Sample"><span id="page_viii">5</span></span></p>
<p class="C91"><strong><span href="#/xhtml/11_5__Past#page_132" title="Link target outside of Sample">Past and Future</span></strong></p>
<p class="C91"><em><span href="#/xhtml/11_5__Past#page_132" title="Link target outside of Sample">What Do Former Lingua Francas of Science Tell Us?</span></em></p>
<p class="C155"><span href="#/xhtml/12_6__Does#page_166" title="Link target outside of Sample">6</span></p>
<p class="C91"><strong><span href="#/xhtml/12_6__Does#page_166" title="Link target outside of Sample">Does Science Need a Global Language?</span></strong></p>
<p class="C155"><em><span href="#/xhtml/13_Notes#page_189" title="Link target outside of Sample">Notes</span></em></p>
<p class="C89"><em><span href="#/xhtml/14_Index#page_215" title="Link target outside of Sample">Index</span></em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Contents.vue?07630edc